<template>
  <v-data-table
    item-key="id"
    disableSort
    :items-per-page="-1"
    :headers="headers"
    :items="items"
    hide-default-footer
    class="mt-3 elevation-1"
  >
    <template v-slot:[`item.index`]="{ item }">
      {{ item | ordinalNumber(items) }}
    </template>
    <template v-slot:[`item.name`]="{ item }">
      <CardStudentName :student="item.student" link />
    </template>
    <template v-slot:[`item.dob`]="{ item }">
      {{ $_get(item, 'student.dob') | ddmmyyyy }}
    </template>
    <template v-slot:[`item.class`]="{ item }">
      {{ $_get(item, 'class.title', '--') }}
    </template>
    <template v-slot:[`item.status`]="{ item }">
      <PopupUpdateStatusChange :id="item.id" :srcStatus="item.status" :srcSubStatus="item.subStatus" />
    </template>
  </v-data-table>
</template>
<script>
import CardStudentName from '@/components/basic/card/CardStudentName.vue'
import PopupUpdateStatusChange from './PopupUpdateStatusChange.vue'
const headers = [
  { text: 'STT', value: 'index' },
  { text: 'Học sinh', value: 'name' },
  { text: 'Ngày sinh', value: 'dob' },
  { text: 'Lớp', value: 'class' },
  { text: 'Thao tác', align: 'center', value: 'status' },
]
export default {
  components: { CardStudentName, PopupUpdateStatusChange },
  props: { items: Array },
  data: () => ({ headers }),
}
</script>
